import React from 'react';
import { IconCurrencyRupee } from '@tabler/icons-react';

/** Label suffix for monetary rate fields: dim grey (₹) */
export function RateLabel({ children }: { children: React.ReactNode }) {
  return (
    <span className="rm-rate-label">
      {children}
      <span className="rm-rate-label__unit" aria-hidden>
        (
        <IconCurrencyRupee size={11} stroke={2} />
        )
      </span>
    </span>
  );
}
